import { render } from "./NotFound.vue?vue&type=template&id=20d8ec4b&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=20d8ec4b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d8ec4b"]])

export default __exports__